import { SettingsManager } from "@viamap/viamap2-common";
import { Adresse, Husnummer } from "./DARTypes";

export class darCollector {


   // Bygning er UUID, fra BBR lokalID
   static async BygningTilAdgang(bygning: string) {
      let query = {
         AdgangTilBygning: bygning
      }
      return await fetchDARGældende("husnummer", query);
   }


   static async AdresserFraID(adresseId: string | string[]) {
      let id = adresseId;
      if (Array.isArray(id)) {
         id = id.join("|");
      }
      let query = {
         id: id
      }
      return await fetchDARGældende("adresse", query);
   }

   // Husnummer er UUID, fra AdgangsAdresser lokalID
   static async AdresserFraHusnummer(husnummer: string) {
      let query = {
         husnummer: husnummer
      }
      return await fetchDARGældende("adresse", query);
   }
}

type DARTypesReturn = {
   adresse: Adresse,
   husnummer: Husnummer,
}

function fetchDARGældende<T extends keyof DARTypesReturn>(endpoint: T, query: { [key: string]: any }): Promise<DARTypesReturn[T]> {
   const serviceUrl = `https://services.datafordeler.dk/DAR/DAR/3.0.0/rest/${endpoint}`;
   const params = {
      format: "json",
      status: "3",
      ...query,
      username: SettingsManager.getSystemSetting("datafordelerUsername"),
      password: SettingsManager.getSystemSetting("datafordelerPassword"),
   };

   return fetch(serviceUrl + `?${new URLSearchParams(params)}`, {
      method: 'GET',
      headers: {
         'Accept': 'application/json'
      }
   }).then(async res => {
      if (!res.ok) {
         await res.text().then(text => {
            console.error("Error response from Mat2:", text);
         });
         throw new Error(`HTTP error! status: ${res.status}`);
      }
      return res.json() as Promise<DARTypesReturn[typeof endpoint]>;
   });
}
